import Vue from "vue";
import Vuex from "vuex";

import { createTimeCharge } from "../models";
import actions, {
    AppActionTypes,
    GetClientItemsAction,
    GetClientsAction,
    GetProjectItemsAction,
    GetSettingsAction,
    GetUserAction,
    GetUserItemsAction
} from "./actions";
import getters, { AppGetterTypes } from "./getters";
import IAppState from "./IAppState";
import mutations, { SetTimeEntryMutation } from "./mutations";

// https://vuex.vuejs.org/
Vue.use(Vuex);

const initialState: IAppState = {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URI || "",
    version: process.env.VUE_APP_VERSION || "",
    prismThemeSettings: {
        lightUrl: process.env.VUE_APP_PRISM_LIGHT_MODE_CSS_THEME_URL || "",
        darkUrl: process.env.VUE_APP_PRISM_DARK_MODE_CSS_THEME_URL || ""
    },
    settings: {
        isAuthenticated: false,
        phoneNumberPattern: "",
        emailPattern: "",
        user: { id: 0, roles: [], userType: 0 },
        taskStatusItems: [],
        activeTaskStatusItems: [],
        externalProjectManagementItems: [],
        internalLinkTypeItems: [],
        timeEntryTypeItems: [],
        taskFeedbackEnvironmentItems: [],
        clientProjectEnvironmentItems: [],
        fullReportExportTypeItems: [],
        stateItems: [],
        newTaskStatusId: 0,
        closedTaskStatusId: 0
    },
    user: { id: 0, userType: 0, roles: [] },
    timeEntry: createTimeCharge(),
    updateAvailable: false,
    clients: [],
    title: window.document.title,
    clientItems: [],
    userItems: [],
    projectItems: {}
};

const store = new Vuex.Store({
    state: initialState,

    // https://vuex.vuejs.org/guide/getters.html
    getters: getters,

    // https://vuex.vuejs.org/guide/mutations.html
    mutations: mutations,

    // https://vuex.vuejs.org/guide/actions.html
    actions: actions
});

export default store;

export {
    AppGetterTypes,
    AppActionTypes,
    GetSettingsAction,
    GetUserAction,
    SetTimeEntryMutation,
    GetProjectItemsAction,
    GetUserItemsAction,
    GetClientsAction,
    GetClientItemsAction
};
